import React, { useState } from "react"
import { Card, CardBody, Collapse } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import ReportTable from "components/Common/ReportTable"
import MonitorQuantificationOrganizationFilter from "./filter"

const MonitorQuantificationOrganizationReportListComponent = ({
  data,
  loading,
  onExportBtnClick,
  onSearchHandler,
  exportStatus,
  onPageClick,
  onChangeRowNumber,
  columns,
  visibleColumns,
  onToggleColumn,
  onReorder,
}) => {
  const [filterOpen, setFilterOpen] = useState(false)

  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  const onAdvancedSearchSubmit = searchData => {
    onSearchHandler(searchData)
  }

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading}
          title={"Quantification Based Organization Report"}
          lgColumn={8}
          exportBtn={true}
          exportBtnLoading={exportStatus?.loading}
          onExportBtnClick={onExportBtnClick}
          rowCount={true}
          onChangeRowNumber={onChangeRowNumber}
          searchBox={false}
          rightBtn={false}
          advnacedSearchBtn={true}
          advnacedSearchBtnTitle={"Filter"}
          onAdvancedSearch={onAdvancedSearchHandler}
        />
        <Collapse isOpen={filterOpen}>
          <MonitorQuantificationOrganizationFilter
            loading={loading}
            onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            columns={columns}
            onToggleColumn={onToggleColumn}
            onReorder={onReorder}
          />
        </Collapse>

        <ReportTable
          visibleColumns={visibleColumns}
          data={data?.data}
          loading={loading}
          pagination={{ meta: data?.meta, onPageClick }}
        />
      </CardBody>
    </Card>
  )
}

export default MonitorQuantificationOrganizationReportListComponent
